/** Shared classes for native color inputs (full-bleed swatch, no padding). */
export const CMS_COLOR_INPUT_CLASS =
  "h-12 w-12 cursor-pointer rounded-md border border-slate-200 bg-transparent p-0 [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:rounded-md [&::-webkit-color-swatch]:border-0";

export const CMS_COLOR_SWATCH_TRIGGER_CLASS =
  "box-border h-9 w-9 shrink-0 overflow-hidden rounded-md border border-slate-200 p-0 shadow-sm ring-1 ring-inset ring-black/10 transition-shadow hover:ring-2 hover:ring-slate-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400";

/** Plain text field aligned with palette controls (avoids double-border Input wrapper). */
export const CMS_PALETTE_TEXT_INPUT_CLASS =
  "flex h-9 w-full min-w-0 rounded-md border border-input bg-white px-3 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

export const CMS_PALETTE_HEX_INPUT_CLASS =
  "h-9 w-28 shrink-0 rounded-md border border-input bg-white px-3 font-mono text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

export const CMS_PALETTE_FIELD_LABEL_CLASS =
  "text-sm font-medium leading-none text-slate-700";

export const CMS_PALETTE_CONTROL_ROW_CLASS = "flex items-center gap-2";
